// extracted by css-extract-rspack-plugin
export default {"colorGray56":"#565656","labelClass":"input__labelClass___CxyRx"};